export const URL_HANDLER_VALIDATION = (url, fields, containQr) => {
  try {
    const params = new URLSearchParams(url);
    const paramObject = {};

    // Extraer parámetros y sus prefijos
    for (const [key, value] of params.entries()) {
      if (PREFIX.some(prefix => key.startsWith(prefix))) {
        const matchedPrefix = PREFIX.find(prefix => key.startsWith(prefix));
        const cleanKey = key.replace(matchedPrefix, '');
        // Guardar tanto el valor como el prefijo
        paramObject[cleanKey] = {
          prefix: matchedPrefix,
          value: value,
        };
      }
    }

    fields.principales = fields.principales.map(field => {
      if (Object.keys(paramObject).includes(field.id.toString())) {
        const isFieldValid = getIfValidate(field, paramObject[field.id].value);
        if (isFieldValid) {
          if (!containQr) {
            return {
              ...field,
              parametro: {
                opcion:
                  paramObject[field.id].prefix === 'r_'
                    ? 'ver'
                    : paramObject[field.id].prefix === 'h_'
                      ? 'ocultar'
                      : 'editar',
                valor: paramObject[field.id].value,
              },
            };
          } else {
            if (
              field.id !== 'id_sucursal' &&
              field.id !== 'id_tercero_cliente' &&
              field.id !== 'id_equipo'
            ) {
              return {
                ...field,
                parametro: {
                  opcion:
                    paramObject[field.id].prefix === 'r_'
                      ? 'ver'
                      : paramObject[field.id].prefix === 'h_'
                        ? 'ocultar'
                        : 'editar',
                  valor: paramObject[field.id].value,
                },
              };
            }
            return field;
          }
        }
      }
      return field;
    });

    fields.atributos = fields.atributos.map(field => {
      if (Object.keys(paramObject).includes(field.id.toString())) {
        const prefix = paramObject[field.id].prefix;
        const isPrefixValid = prefix === 'ra_' || prefix === 'ha_';

        if (isPrefixValid && paramObject[field.id.toString()].value) {
          return {
            ...field,
            parametro: {
              opcion: prefix === 'ra_' ? 'ver' : 'ocultar',
              valor: paramObject[field.id.toString()].value,
            },
            texto:
              paramObject[field.id.toString()].value &&
              paramObject[field.id.toString()].tipo !== 'archivo'
                ? paramObject[field.id].value
                : field.texto,
          };
        }
      }
      return field;
    });
    return fields;
  } catch (error) {
    return fields;
  }
};

const PREFIX = ['r_', 'ra_', 'h_', 'ha_'];

function getIfValidate(field, valor) {
  if (
    field.obligatorio === true &&
    (valor === '' || valor === null || valor === undefined)
  ) {
    return false;
  }
  return true;
}
